import verypay from 'constants/verypay';
import { insuranceVoucherMap } from 'constants/promotion-voucher-constants';


type Content = {
  [key: string]: string;
};

export default {
  ...verypay,
  ...insuranceVoucherMap
  } as Content;
